import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Intake from "@/pages/Intake";
import EvaluationReady from "@/pages/EvaluationReady";
import Results from "@/pages/Results";
import SignUp from "@/pages/SignUp";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ReportView from "@/pages/ReportView";
import Tracker from "@/pages/Tracker";
import Avatar from "@/pages/Avatar";
import Household from "@/pages/Household";
import Navbar from "@/components/Navbar";
import { AuthCallback } from "@/components/AuthCallback";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/intake" element={<Intake />} />
      <Route path="/evaluation-ready" element={<EvaluationReady />} />
      <Route path="/results" element={<Results />} />
      <Route path="/tracker" element={<Tracker />} />
      <Route path="/avatar" element={<Avatar />} />
      <Route path="/household" element={<Household />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/reports/:id" element={<ReportView />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Navbar />
          <AppRouter />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
